import React from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import PresidentProfile from './components/PresidentProfile';
import OrganizationDetails from './components/OrganizationDetails';
import OfficeBearers from './components/OfficeBearers';
import WorkingSectors from './components/WorkingSectors';
import Gallery from './components/Gallery';
import Footer from './components/Footer';

function App() {
  return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      
      {/* 1. Navbar */}
      <Navigation />

      {/* 2. Hero Section */}
      <Hero />

      {/* Main Content Sections with IDs for Navbar Scrolling */}
      <main className="container py-5">
        
        <section id="about" className="mb-5 pt-4">
          <PresidentProfile />
        </section>

        <section id="details" className="mb-5 pt-4">
          <OrganizationDetails />
        </section>
        
        <section id="sectors" className="mb-5 pt-4">
          <div className="row g-4">
            <div className="col-lg-6">
              <OfficeBearers />
            </div>
            <div className="col-lg-6">
              <WorkingSectors />
            </div>
          </div>
        </section>

        <section id="gallery" className="mb-5 pt-4">
          <Gallery />
        </section>

      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;